import { Calendar } from '../components/calendar'
import { CalendarProvider } from '../components/calendar-provider'
import { usePageTitle } from '$components'

export function CalendarPage() {
  usePageTitle('Calendar')

  return (
    <CalendarProvider>
      <Calendar />
    </CalendarProvider>
  )
}
